import { Injectable } from '@angular/core';
import {Params} from '@angular/router';
import {AssetStateService} from '../assets/asset.state.service';
import {AssetFilter} from '../assets/asset-filter';

@Injectable({
  providedIn: 'root'
})
export class QueryParamsToFilterService {
  filter: AssetFilter | undefined;
  constructor(
      private assetStateService: AssetStateService,
  ) {}

  parseQueryParams(params: Params): void {
    this.filter = this.assetStateService.createDefaultAssetFilter()
    if (this.filter) {
      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          for (const filterKey in this.filter) {
            if (this.filter.hasOwnProperty(filterKey)) {
              if (filterKey === key) {
                if (Array.isArray(params[key])) {
                  this.filter[key] = params[key];
                } else {
                  // @ts-ignore
                  if (Array.isArray(this.filter[key])) {
                    // @ts-ignore
                    this.filter[key].push(params[key]);
                  } else {
                    this.filter[key] = params[key];
                  }

                }

              }

            }
          }
        }
      }
    }
   // console.log('filter', this.filter);
   this.assetStateService.filter = this.filter
  }
}
